export const loadPage = (path: string) => window.location.assign(path);
